import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { PRODUCT_HUBS } from '../data/copy';
import { HERO_MEDIA } from '../config/media';

export const ProductHubsGrid = () => (
    <section
        className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28"
        data-testid="product-hubs"
    >
        <span className="eyebrow">The Product Line</span>
        <h2 className="h-display mt-6 max-w-3xl text-3xl sm:text-4xl">
            Built for the four jobs that move Western Canada.
        </h2>
        <div className="mt-12 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
            {PRODUCT_HUBS.map((p) => {
                const m = HERO_MEDIA[p.mediaKey];
                return (
                    <Link
                        key={p.to}
                        to={p.to}
                        data-testid={`product-hub-${p.to.replace('/', '')}`}
                        className="group relative flex flex-col overflow-hidden border border-brand-hairline bg-brand-surface transition-colors duration-200 hover:border-brand-gold"
                    >
                        <div className="aspect-[4/3] w-full overflow-hidden bg-brand-elevated">
                            {m && m.src ? (
                                <img
                                    src={m.src}
                                    alt={m.alt}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                            ) : null}
                        </div>
                        <div className="flex flex-1 flex-col gap-3 p-6">
                            <h3 className="font-display text-xl font-bold uppercase tracking-tight text-brand-text">
                                {p.title}
                            </h3>
                            <p className="font-sans text-sm leading-relaxed text-brand-muted">
                                {p.valueProp}
                            </p>
                            <span className="mt-auto inline-flex items-center gap-2 font-display text-xs font-bold uppercase tracking-[0.18em] text-brand-gold transition-transform duration-200 group-hover:translate-x-1">
                                Explore <ArrowRight size={14} />
                            </span>
                        </div>
                    </Link>
                );
            })}
        </div>
    </section>
);

export default ProductHubsGrid;
